<template>
  <UiDrawer v-model="drawerVisible" :custom-class="drawerClass" :size="$store.state.app.isWideScreen ? '90%' : '60%'" :modal-append-to-body="false" :direction="$store.state.app.isWideScreen ? 'btt' : 'ltr'">
    <template slot="title">
      <div class="operational-order-drawer__title"><i class="iconfont icon-jinjidingdan"></i><h3>{{ $t("待处理订单") }}</h3></div>
    </template>
    <OperationalOrderPanel :shop-id="shopId" :allow-all-shops="allowAllShops" @update:shop-id="$emit('update:shop-id', $event)" @close="drawerVisible = false" />
  </UiDrawer>
</template>

<script>
import OperationalOrderPanel from '@/components/OperationalOrderPanel'
export default {
  name: 'OperationalOrderDrawer',
  components: { OperationalOrderPanel },
  props: {
    value: { type: Boolean, default: false },
    shopId: { type: [String, Number], default: '' },
    allowAllShops: { type: Boolean, default: false }
  },
  computed: {
    drawerVisible: {
      get () { return this.value },
      set (visible) { this.$emit('input', visible) }
    },
    drawerClass () {
      const sizeClass = this.$store.state.app.isWideScreen ? 'el-drawer-small' : 'el-drawer-large'
      return `${sizeClass} operational-order-drawer`
    }
  }
}
</script>

<style lang="scss" scoped>
.operational-order-drawer__title { display: flex; align-items: center; gap: var(--ui-space-xs); }
.operational-order-drawer__title > i { font-size: var(--ui-font-size-overlay-title); font-weight: 400; }
.operational-order-drawer__title > h3 { margin: 0; }
</style>
